import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../api";

import { Alert, Input } from 'reactstrap';

import ParadigmaAsyncSeeker from "../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaLabeledInput from "../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"
import ParadigmaDatePicker from "../../components/ParadigmaDatePicker/ParadigmaDatePicker.js"

import moment from 'moment';


class Modal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nombre:'',
            tipoEvento_id:'',
            comienzo:moment(),
            fin:moment(),
            descripcion:'',
            visible:1, //1: Usuario, 2: Todos
            usuario_id:null,

            entreFechas: false,
            resuelta: false,
            fecha_resuelta: null,

            postVariables: ['nombre', 'tipoEvento_id', 'comienzo', 'fin', 'descripcion', 'visible', 'usuario_id', 'resuelta', 'fecha_resuelta'],
            errors: [],
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func,
        id: PropTypes.func,
        action: PropTypes.oneOf(['CREATE', 'EDIT', 'DETAIL', 'DELETE', 'RESOLVER']).isRequired,
    }

    resetForm() {
        this.setState({
            nombre:'',
            tipoEvento_id:'',
            comienzo:moment(),
            fin:moment(),
            descripcion:'',
            visible:1,
            usuario_id:null,
            resuelta: false,
            fecha_resuelta: null,

            entreFechas: false,

            errors: [],
        });
    }

    getData() {
        const { postVariables, entreFechas, visible } = this.state;
        let data = {};

        postVariables.forEach(x => {
            data[x] = this.state[x];
        });

        data['comienzo'] = this.state.comienzo.format('YYYY-MM-DD HH:mm');

        if(!entreFechas){
            data['fin'] = this.state.comienzo.format('YYYY-MM-DD HH:mm');
        }else{
            data['fin'] = this.state.fin.format('YYYY-MM-DD HH:mm');
        }
        if(this.props.action == "RESOLVER"){
             data["resuelta"] = true;
             data["fecha_resuelta"] = moment().format("YYYY-MM-DD HH:mm");
        }
        return data;
    }

    setData(data) {
        if (data.success) {
            this.setState({
                nombre: data.nombre,
                tipoEvento_id: (data.tipoEvento) ? (data.tipoEvento.id) : (null),
                comienzo: moment(data.comienzo),
                fin: moment(data.fin),
                descripcion: data.descripcion,
                visible: data.visible,
                usuario_id: (data.usuario) ? (data.usuario.id) : (null),
                resuelta: (data.resuelta) ? (data.resuelta) : (false),
                fecha_resuelta: (data.fecha_resuelta) ? moment(data.fecha_resuelta) : (null),
                entreFechas: (data.comienzo!=data.fin),
            });
        }
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            if (field === "imagen") {
                value = value === "Imagen" ? true : false;
                prevState[field] = value;
            }
            else
                prevState[field] = value;
            return prevState;
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    onValidation(){
        const {
             nombre, tipoEvento_id, comienzo, fin,
             visible, usuario_id, resuelta, fecha_resuelta,
             entreFechas
        } = this.state;
        let error = {};
        let validate = true;

        if (nombre==''){
            error.nombre= [{code: "required", detail: "Nombre no puede estar en blanco"}];
            validate = false;
        }
        if(tipoEvento_id==null){
            error.tipoEvento_id= [{code: "required", detail: "Seleccione un tipo de evento"}]
            validate = false;
        }
        if(entreFechas){
            if(comienzo.isAfter(fin)){
                error.fin= [{code: "required", detail: "Fecha fin debe ser posterior a la de comienzo"}]
                validate = false;
            }
        }
        if(visible==1){
            if(usuario_id==null){
                error.usuario_id= [{code: "required", detail: "Seleccione un usuario"}]
                validate = false;
            }
        }

        this.setState({
            errors: error,
        })
        return validate;
    }

    modalVars() {
        const { action } = this.props;
        if (action == "CREATE") {
            return {
                get: false,
                submitType: "POST",
                title: "Nuevo Evento",
                danger: false,
                buttonLabel:" Crear Evento",
                buttonIcon: "fa fa-plus fa-lg",
                successMessage: "El Evento ha sido creado con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar y salir",
                buttonClass: "ui-calendar-action-button",
                saveReloadButton: true,
                saveReloadButtonLabel: 'Guardar',
                disabled: false,
            };
        } else if (action == "EDIT") {
            return {
                get: true,
                submitType: "PUT",
                title: "Editar Evento",
                danger: false,
                buttonIcon: "fa fa-pencil fa-lg",
                successMessage: "El Evento ha sido editado con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "ui-calendar-menu-action",
                disabled: false,
                id: this.props.id,
                buttonLabel: "Editar"
            };
        } else if (action == "DETAIL") {
            return {
                get: true,
                submitType: null,
                title: "Evento",
                danger: false,
                buttonIcon: "fa fa-search fa-lg",
                successMessage: "",
                saveButton: false,
                buttonClass: "ui-calendar-menu-action",
                disabled: true,
                id: this.props.id,
                buttonLabel: "Detalle"
            };
        } else if (action == "DELETE") {
            return {
                get: true,
                submitType: "DELETE",
                title: "Eliminar Evento",
                danger: true,
                buttonIcon: "fa fa-trash fa-lg",
                successMessage: "El Evento ha sido eliminada con éxito.",
                saveButton: true,
                saveButtonLabel: "Eliminar",
                buttonClass: "ui-calendar-menu-action",
                disabled: true,
                id: this.props.id,
                buttonLabel: "Eliminar"
            };
       } else if (action == "RESOLVER") {
            return {
                get: true,
                submitType: "PUT",
                title: "Marcar como Evento Resuelto",
                danger: false,
                buttonIcon: "fa fa-check-circle fa-lg",
                successMessage: "El Evento ha sido editado como resuelto.",
                saveButton: true,
                saveButtonLabel: "Confirmar",
                buttonClass: "ui-calendar-menu-action",
                disabled: false,
                id: this.props.id,
                buttonLabel: "Resolver"
            };
        }
    }

    onSubmit = (e) => {
        this.props.onSubmit();
        this.resetForm();
        return true;
    }

    onOpen = () => {
        const { usuario_id, } = this.props;

        this.setState({
            usuario_id: usuario_id,
        })
    }

    render() {
        let vars = this.modalVars();
        const { nombre, tipoEvento_id, comienzo, fin, descripcion, visible, usuario_id, resuelta, fecha_resuelta, entreFechas } = this.state;
        const disableIfResolve = this.props.action == "RESOLVER" || resuelta == true;
        const inputDisabled = vars.disabled || disableIfResolve;
        const fieldClassNames = ["ui-field-label-col", "ui-field-control-col"];
        return (
            <ParadigmaModal
                getUrl={(vars.get ? api.calendar.eventosCalendar : null)}
                submitUrl={(vars.submitType ? api.calendar.eventosCalendar : null)}
                submitType={vars.submitType}
                id={vars.id}
                onGotData={(data) => this.setData(data)}
                onGotErrors={(errors) => this.setErrors(errors)}
                onSubmit={(e) => this.onSubmit(e)}
                onOpen={() => this.onOpen()}
                onClose={() => this.resetForm()}
                onPreSubmit={() => this.getData()}
                onValidation={() => this.onValidation()}
                title={vars.title}

                danger={vars.danger}
                buttonClass={vars.buttonClass}

                successMessage={vars.successMessage}
                missingIdMessage={"Debe seleccionar una fila."}
                saveButtonLabel={vars.saveButtonLabel}
                buttonTitle={vars.buttonTitle}
                buttonIcon={vars.buttonIcon}
                saveButton={vars.saveButton}
                saveReloadButton={vars.saveReloadButton}
                saveReloadButtonLabel={vars.saveReloadButtonLabel}
                closeButton={true}

                buttonLabel={(vars.buttonLabel) ? (vars.buttonLabel) : ('')}
                className="ui-paradigma-modal ui-paradigma-modal-wide"
            >

                <section className="ui-modal-section">
                    <p className="ui-section-label">Detalle del evento</p>
                    <div className="ui-form-grid">
                        <ParadigmaLabeledInput
                            label="Nombre"
                            md={[12, 12]}
                            classNames={fieldClassNames}
                            value={nombre}
                            disabled={inputDisabled}
                            onChange={(e) => this.onChangeField('nombre', e.target.value)}
                            error={() => this.getError('nombre')}
                        />

                        <ParadigmaLabeledInput
                            label="Tipo de Evento"
                            md={[12, 12]}
                            classNames={fieldClassNames}
                            inputComponent={
                                <ParadigmaAsyncSeeker
                                    disabled={inputDisabled}
                                    url={api.calendar.tipoEventos}
                                    value={tipoEvento_id}
                                    parameters={{
                                        paginationEnabled:false,
                                        sort:['nombre']
                                    }}
                                    onChange={e => this.onChangeField('tipoEvento_id', (e) ? (e.id) : (null))}
                                />
                            }
                            error={() => this.getError('tipoEvento_id')}
                        />

                        <div className="ui-span-2">
                            <div className={'ui-calendar-date-row' + (entreFechas ? ' is-range' : '')}>
                                <ParadigmaLabeledInput
                                    disabled={inputDisabled}
                                    md={[12, 12]}
                                    classNames={fieldClassNames}
                                    label={"Comienzo"}
                                    inputComponent={
                                        <ParadigmaDatePicker
                                            disabled={inputDisabled}
                                            value={comienzo}
                                            onChange={(e) => this.setState({ 'comienzo': e })}
                                            datetime={true}
                                            className={"dp_datetime"}
                                        />}
                                    error={() => this.getError('comienzo')}
                                />

                                <div className="ui-calendar-range-toggle">
                                    <label className={'ui-checkbox-field' + (inputDisabled ? ' is-disabled' : '')}>
                                        <input
                                            type="checkbox"
                                            disabled={inputDisabled}
                                            checked={entreFechas}
                                            onChange={(e) => this.setState({entreFechas: e.target.checked})}
                                        />
                                        <span>Entre Fechas</span>
                                    </label>
                                </div>

                                {(entreFechas) && (
                                    <ParadigmaLabeledInput
                                        disabled={inputDisabled}
                                        md={[12, 12]}
                                        classNames={fieldClassNames}
                                        label={"Fin"}
                                        inputComponent={
                                            <ParadigmaDatePicker
                                                disabled={inputDisabled}
                                                value={fin}
                                                onChange={(e) => this.setState({ 'fin': e })}
                                                datetime={true}
                                                className={"dp_datetime"}
                                            />}
                                        error={() => this.getError('fin')}
                                    />
                                )}
                            </div>
                        </div>

                        <div className="ui-span-2">
                            <ParadigmaLabeledInput
                                label="Descripción"
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                type="textarea"
                                rows={3}
                                disabled={inputDisabled}
                                value={descripcion}
                                onChange={(e) => this.onChangeField('descripcion', e.target.value)}
                                error={() => this.getError('descripcion')}
                            />
                        </div>
                    </div>
                </section>

                <section className="ui-modal-section">
                    <p className="ui-section-label">Visibilidad</p>
                    <div className="ui-choice-grid">
                        <label
                            className={'ui-choice-card' + (visible === 2 ? ' is-selected' : '') + (inputDisabled ? ' is-disabled' : '')}
                            onClick={() => inputDisabled ? null : this.onChangeField('visible', 2)}
                        >
                            <input
                                type="radio"
                                disabled={inputDisabled}
                                name="group1"
                                className="with-gap filled-in"
                                value="2"
                                onChange={() => this.onChangeField('visible', 2)}
                                checked={visible === 2}
                            />
                            <span>Todos</span>
                        </label>
                        <label
                            className={'ui-choice-card' + (visible === 1 ? ' is-selected' : '') + (inputDisabled ? ' is-disabled' : '')}
                            onClick={() => inputDisabled ? null : this.onChangeField('visible', 1)}
                        >
                            <input
                                type="radio"
                                disabled={inputDisabled}
                                name="group1"
                                className="with-gap filled-in"
                                value="1"
                                onChange={() => this.onChangeField('visible', 1)}
                                checked={visible === 1}
                            />
                            <span>Usuario</span>
                        </label>
                    </div>

                    {(visible==1) && (
                        <div className="ui-form-grid ui-calendar-user-grid">
                            <ParadigmaLabeledInput
                                label="Usuario"
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                error={() => this.getError('usuario_id')}
                                inputComponent={
                                    <ParadigmaAsyncSeeker
                                        disabled={inputDisabled}
                                        url={api.vendedores.usuarios}
                                        value={usuario_id}
                                        onChange={data => this.onChangeField('usuario_id', data ? data.id : null)}
                                        parameters={{
                                            paginationEnabled:false,
                                            sort:['last_name'],
                                       }}
                                        valueRenderer={data => `${data.last_name} ${data.first_name}`}
                                        optionRenderer={data => `${data.last_name} ${data.first_name}`}
                                    />
                                }
                            />
                        </div>)
                    }
                </section>

                {
                    resuelta == true &&
                    <Alert color="info" className="ui-alert ui-alert-info mb-0">
                        {`La tarea fue resuelta el ${moment(fecha_resuelta).format("DD-MM-YYYY HH:mm")}`}
                    </Alert>
                }
            </ParadigmaModal>
        );
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/Calendar/Modal.js